const CollegeAdmissions = () => {
  return (
    <div className="h-screen flex items-center justify-center">
      College admissions: Page is under development
    </div>
  );
};

export default CollegeAdmissions;
